import { render, staticRenderFns } from "./ServicesNavItem.vue?vue&type=template&id=6f4504d6&"
import script from "./ServicesNavItem.vue?vue&type=script&lang=js&"
export * from "./ServicesNavItem.vue?vue&type=script&lang=js&"
import style0 from "./ServicesNavItem.vue?vue&type=style&index=0&id=6f4504d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports